import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthFooter from '../atoms/footer/AuthFooter';

const AuthLayout = ({ children, logoClickable = false, maxWidth }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col overflow-y-auto relative" style={{ background: 'linear-gradient(135deg, #0f0c29, #1a1a4e, #24243e)' }}>
      <style>{`
        @keyframes orb-float-1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(60px, -80px) scale(1.1); }
          66% { transform: translate(-40px, 40px) scale(0.95); }
        }
        @keyframes orb-float-2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-70px, 50px) scale(1.05); }
          66% { transform: translate(50px, -60px) scale(0.9); }
        }
        @keyframes orb-float-3 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(40px, 70px) scale(1.08); }
        }
        @keyframes grid-pulse {
          0%, 100% { opacity: 0.03; }
          50% { opacity: 0.07; }
        }
        .auth-orb-1 { animation: orb-float-1 12s ease-in-out infinite; }
        .auth-orb-2 { animation: orb-float-2 16s ease-in-out infinite; }
        .auth-orb-3 { animation: orb-float-3 10s ease-in-out infinite; }
        .auth-grid { animation: grid-pulse 6s ease-in-out infinite; }
        .auth-btn-primary {
          background: linear-gradient(135deg, #6366f1, #8b5cf6);
          box-shadow: 0 4px 20px rgba(99,102,241,0.4);
          transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
        }
        .auth-btn-primary:hover:not(:disabled) {
          filter: brightness(1.12);
          box-shadow: 0 6px 28px rgba(99,102,241,0.55);
          transform: translateY(-1px);
        }
        .auth-btn-primary:active:not(:disabled) {
          transform: translateY(0px) scale(0.98);
          box-shadow: 0 2px 12px rgba(99,102,241,0.35);
          filter: brightness(0.96);
        }
        .auth-btn-primary:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="auth-orb-1 absolute w-[600px] h-[600px] rounded-full" style={{ top: '-150px', left: '-100px', background: 'radial-gradient(circle, rgba(99,102,241,0.35) 0%, transparent 70%)' }} />
        <div className="auth-orb-2 absolute w-[500px] h-[500px] rounded-full" style={{ bottom: '-100px', right: '-80px', background: 'radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)' }} />
        <div className="auth-orb-3 absolute w-[400px] h-[400px] rounded-full" style={{ top: '40%', left: '55%', background: 'radial-gradient(circle, rgba(59,130,246,0.2) 0%, transparent 70%)' }} />
        <div className="auth-grid absolute inset-0" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
      </div>

      <div className={`relative z-10 flex items-center px-8 py-4 flex-shrink-0 ${logoClickable ? 'cursor-pointer' : ''}`} onClick={logoClickable ? () => navigate(localStorage.getItem('token') ? '/' : '/signin', { replace: true }) : undefined}>
        <img src="/images/icons/logo.svg" alt="Workflo" className="h-5" style={{ filter: 'brightness(0) invert(1)', opacity: 0.85 }} />
      </div>

      <div className="relative z-10 flex-1 flex items-start justify-center px-4 py-8">
        <div className="w-full max-w-md" style={maxWidth ? { maxWidth } : {}}>
          <div className="rounded-2xl px-8 py-10" style={{ background: 'rgba(255,255,255,0.07)', backdropFilter: 'blur(24px)', border: '1px solid rgba(255,255,255,0.12)', boxShadow: '0 25px 60px rgba(0,0,0,0.4)' }}>
            {children}
          </div>
        </div>
      </div>

      <div className="relative z-10">
        <AuthFooter dark />
      </div>
    </div>
  );
};

export default AuthLayout;
